$( document ).ready(function() {
    if($(window).width() > 1200){
        $('.content-section-zolt-oem__ul ').slick({
            centerMode: true,
            slidesToShow: 3,
            centerPadding: '100px',
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    // $( ".content-section-zolt-oem__li" ).each(function( index ) {
    //     const $slider = $('.content-section-zolt-oem__ul');
    //     const $slide = $('.content-section-zolt-oem__li');
    //     let isPaused = false;
    //     let isCenter = 1;
    //     let dataIndex = 1;

        // $slide.on('mouseenter', function () {
        //     if($(this).hasClass('slick-center')){
        //         if (isPaused) {
        //             isPaused = false;
        //         }
        //     }
        //     if (!isPaused
        //         && !$(this).hasClass('slick-center')
        //         && parseInt($(this).data('index')) !== parseInt(dataIndex)
        //     ) {
        //         setTimeout(() => {
        //             dataIndex = $(this).data('index');
        //             isPaused = true;
        //             isCenter = dataIndex;
        //             $slider.slick('slickGoTo', dataIndex-1);
        //         }, "100");
        //     }
        // });
    // });

    $(window).on('resize', function () {
        const width = $(window).width();
        if(width <= 1200){
            $('.content-section-zolt-oem__ul ').slick('unslick');
        }else{
            $('.content-section-zolt-oem__ul ').slick({
                centerMode: true,
                slidesToShow: 3,
                centerPadding: '100px',
                arrows: false,
                infinite: true,
                // autoplay: true,
                // autoplaySpeed: 5000,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            arrows: false,
                            centerMode: true,
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    });
});